<template>
    <div class="row">
        <div class="col-md-12">
            <h1>Fidélité</h1>
        </div>
        <lps-list></lps-list>
    </div>
</template>

<script>
import lpsList from 'components/LoyaltyProgramSubscriptions/LpsList'

export default {
    name: 'LPS',

    components: {
        lpsList
    }
}
</script>



// WEBPACK FOOTER //
// client/views/LoyaltyProgramSubscriptions/LoyaltyProgramSubscriptions.vue